import {environment} from './environments/environment';
import {enableProdMode} from "@angular/core";
import {bootstrapApplication} from "@angular/platform-browser";
import {AppComponent} from "@/app/app.component";
import {appConfig} from "@/app/app.config";

if (environment.production) {
    enableProdMode();
    console.log("Приложение запущено в режиме продакшена. ")
}
if (!environment.production) {
    console.log('Приложение запущено в режиме разработки.');
}

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
